// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"list-3gxfUk12","img":"img-YLAIiss7"};